import React from "react";
import Loadable from "react-loadable";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { AsynLoader } from "../Loader/AsynLoader";
import Modal from "../Modals";
import { queryStringPrice } from "../../actions";
import {
  generateQueryStringFromReduxState,
  queryString,
  convertBudgetValueAccordingToCurrency
} from "../../utils";

class Budget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      min: "",
      max: "",
      str: "",
      showModal: false,
      redirect: ""
    };
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }
  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
    const { from, to } = this.props.query.price;
    this.setState({ min: from, max: to });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.query.price !== prevProps.query.price ||
      this.props.currency !== prevProps.currency
    ) {
      const { from, to } = this.props.query.price;
      const { currency } = this.props;
      if (to) {
        this.generateStringFromRange(parseInt(from, 10), parseInt(to, 10), currency);
      }
      this.setState({ min: from, max: to });
    }
  }

  detectClickOutSide = e => {
    if (window.innerWidth > 700)
      if (!this.budgetRef.contains(e.target)) {
        this.setState({ showModal: false });
      }
  };

  handleSelect = (min, max, str) => {
    let q = generateQueryStringFromReduxState(this.props.query);

    q.priceFrom = min;
    q.priceTo = max;

    this.setState({
      min,
      max,
      str,
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringPrice({ from: min, to: max });
  };

  handleReset = () => {
    let q = generateQueryStringFromReduxState(this.props.query);

    delete q.priceFrom;
    delete q.priceTo;

    this.setState({
      min: "",
      max: "",
      str: "Budget",
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringPrice({});
  };
  handleResetCross = e => {
    e.stopPropagation();
    this.handleReset();
  };

  generateStringFromRange = (min, max, curr) => {
    if (min !== "" && max && max !== "") {
      console.log(curr.code, min, max);
      switch (curr.code) {
        case "INR":
          if (min < 5000) {
            this.setState({ str: `Under ${curr.icon}${max}` });
          } else if (min < 10000) {
            this.setState({ str: `${curr.icon}${min} - ${curr.icon}${max}` });
          } else if (min < 20000) {
            this.setState({ str: `${curr.icon}${min} - ${curr.icon}${max}` });
          } else if (min >= 20000) {
            this.setState({ str: `Over ${curr.icon}${min}` });
          }
          break;
        default:
          if (min < 50) {
            this.setState({ str: `Under ${curr.icon}${max}` });
          } else if (min < 100) {
            this.setState({ str: `${curr.icon}${min} - ${curr.icon}${max}` });
          } else if (min < 200) {
            this.setState({ str: `${curr.icon}${min} - ${curr.icon}${max}` });
          } else if (min >= 200) {
            this.setState({ str: `Over ${curr.icon}${min}` });
          }
      }
    }
  };
  render() {
    const { active } = this.props;
    return (
      <div className="t-container-fluid" ref={node => (this.budgetRef = node)}>
        {this.state.redirect !== "" && <Redirect to={this.state.redirect} />}
        <div
          className={`filter__buttons__tertiary ${active ? "active" : ""}`}
          onClick={() => this.setState(prev => ({ showModal: !prev.showModal }))}
        >
          <div
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
            dangerouslySetInnerHTML={{
              __html: this.state.str !== "" ? this.state.str : "Budget"
            }}
          />
          {active && <div className="clear" onClick={this.handleResetCross} />}
        </div>
        {this.state.showModal && (
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <Modal close={() => this.setState({ showModal: false })} reset={this.handleReset}>
                    <AsynBudgetModal
                      handleSelect={this.handleSelect}
                      min={this.state.min}
                      max={this.state.max}
                      currency={this.props.currency}
                    />
                  </Modal>
                );
              } else {
                return (
                  <ul className=" dropdown__list">
                    <li
                      className="item"
                      onClick={() =>
                        this.handleSelect(
                          convertBudgetValueAccordingToCurrency(0, this.props.currency.code),
                          convertBudgetValueAccordingToCurrency(50, this.props.currency.code),
                          `Under ${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                            50,
                            this.props.currency.code
                          )}`
                        )
                      }
                      dangerouslySetInnerHTML={{
                        __html: `Under ${
                          this.props.currency.icon
                        }${convertBudgetValueAccordingToCurrency(50, this.props.currency.code)}`
                      }}
                    />
                    <li
                      className="item"
                      onClick={() =>
                        this.handleSelect(
                          convertBudgetValueAccordingToCurrency(50, this.props.currency.code),
                          convertBudgetValueAccordingToCurrency(100, this.props.currency.code),
                          `${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                            50,
                            this.props.currency.code
                          )} - ${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                            100,
                            this.props.currency.code
                          )}`
                        )
                      }
                      dangerouslySetInnerHTML={{
                        __html: `${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                          50,
                          this.props.currency.code
                        )} - ${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                          100,
                          this.props.currency.code
                        )}`
                      }}
                    />
                    <li
                      className="item"
                      onClick={() =>
                        this.handleSelect(
                          convertBudgetValueAccordingToCurrency(100, this.props.currency.code),
                          convertBudgetValueAccordingToCurrency(200, this.props.currency.code),
                          `${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                            100,
                            this.props.currency.code
                          )} - ${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                            200,
                            this.props.currency.code
                          )}`
                        )
                      }
                      dangerouslySetInnerHTML={{
                        __html: `${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                          100,
                          this.props.currency.code
                        )} - ${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                          200,
                          this.props.currency.code
                        )}`
                      }}
                    />
                    <li
                      className="item"
                      onClick={() =>
                        this.handleSelect(
                          convertBudgetValueAccordingToCurrency(200, this.props.currency.code),
                          convertBudgetValueAccordingToCurrency(500000, this.props.currency.code),
                          `Over ${this.props.currency.icon}${convertBudgetValueAccordingToCurrency(
                            200,
                            this.props.currency.code
                          )}`
                        )
                      }
                      dangerouslySetInnerHTML={{
                        __html: `Over ${
                          this.props.currency.icon
                        }${convertBudgetValueAccordingToCurrency(200, this.props.currency.code)}`
                      }}
                    />
                  </ul>
                );
              }
            }}
          </MediaQuery>
        )}
      </div>
    );
  }
}

const AsynBudgetModal = Loadable({
  loader: () => import("../Modals/Budget"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const mapStateToProps = state => {
  return {
    query: state.queryString,
    currency: state.currency.current
  };
};
const mapDispatchToProps = dispatch => {
  return {
    queryStringPrice: price => dispatch(queryStringPrice(price))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Budget);
